import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';
import PackageStatus from 'components/PackageStatus';

import { PackageListRow_package$key } from '__generated__/PackageListRow_package.graphql';

type Props = EntityTableRowProps & {
  package: PackageListRow_package$key;
};

const PackageListRow: FC<Props> = props => {
  const packageData = useFragment(
    graphql`
      fragment PackageListRow_package on Package {
        id
        name
        price
        createdAt
        updatedAt
        status

        createdBy {
          name
        }

        updatedBy {
          name
        }

        # ...PackageListWarnings_package
        ...EntityTableRow_entity
        ...PackageStatus_package
      }
    `,
    props.package
  );

  const { onDelete } = props;
  const { id, name, price, createdAt, createdBy, updatedAt, updatedBy } =
    packageData;

  return (
    <EntityTableRow entity={packageData} onDelete={onDelete}>
      <TableCell>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          {/* <PackageListWarnings package={pack} /> */}

          <Link href={`/packages/${id}`}>{name}</Link>
        </Box>
      </TableCell>

      <TableCell center>
        <PackageStatus package={packageData} />
      </TableCell>

      <TableCell center>{price && `€${price}`}</TableCell>

      <TableCell center>
        <div>{createdAt}</div>
        <div>{createdBy?.name}</div>
      </TableCell>

      <TableCell center>
        <div>{updatedAt}</div>
        <div>{updatedBy?.name}</div>
      </TableCell>
    </EntityTableRow>
  );
};

export default PackageListRow;
